<template>
  <div class="block_wrap">

    <div class="line">
      <div class="filter checkbox">
        <div class="info">
          {{ translate('client.settings.autoblock_untariffied_devices') }}
        </div>
        <label class="switch" @click.prevent="main_info.autoblock_untariffied_devices  = !main_info.autoblock_untariffied_devices ">
          <input type="checkbox" v-model="main_info.autoblock_untariffied_devices " >
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="line">
      <div class="text_wrap flex2">
        <fg-input
            v-model="monthly_traffic_cost_limit"
            type="number"
            :label="translate('client.settings.monthly_traffic_cost_limit') + ' (USD)'"
            :readonly="false"
        />
      </div>

      <div class="text_wrap flex5">
        <fg-input
            v-model="main_info.custom_logo"
            type="text"
            :label="translate('client.settings.custom_logo')"
            :readonly="true"
        />
      </div>

      <div class="text_wrap flex5">
        <fg-input
            v-model="main_info.initiator_info"
            type="text"
            :label="translate('client.settings.initiator_info')"
            :readonly="true"
        />
      </div>
    </div>

    <div class="line" v-if="has_changes">
      <div class="button_wrap">
        <button
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="edit_clients"
        >
          {{ translate("btn.edit") }}
        </button>
      </div>
    </div>

    <div class="response_table">
      <div class="title">
        <h4>
          {{ translate("client.settings.additional_client_settings") }}
          ({{ translate("client.settings.total") }}: {{ client_settings.length }})
        </h4>
      </div>
      <table>
        <thead>
        <tr>
          <th
              class="pointer"
              @click="change_filter('section')"
              :class="{ selected: filter_type === 'section' }"
              scope="col"
          >
            {{ translate('client.settings.section') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer"
              @click="change_filter('name')"
              :class="{ selected: filter_type === 'name' }"
              scope="col"
          >
            {{ translate('client.settings.name') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer"
              @click="change_filter('value')"
              :class="{ selected: filter_type === 'value' }"
              scope="col"
          >
            {{ translate('client.settings.value') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer"
              @click="change_filter('ts_create')"
              :class="{ selected: filter_type === 'ts_create' }"
              scope="col"
          >
            {{ translate('client.settings.ts_create') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer"
              @click="change_filter('ts_update')"
              :class="{ selected: filter_type === 'ts_update' }"
              scope="col"
          >
            {{ translate('client.settings.ts_update') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(setting,key) in client_settings"
            :key="key"
            class="user"
        >
          <td :data-label="translate('client.settings.section')">
            {{ setting.section }}
          </td>
          <td :data-label="translate('client.settings.name')">
            {{ setting.name }}
          </td>
          <td :data-label="translate('client.settings.value')">
            {{ setting.value }}
          </td>
          <td :data-label="translate('client.settings.ts_create')">
            {{ get_date(setting.ts_create) }}
          </td>
          <td :data-label="translate('client.settings.ts_update')">
            {{ get_date(setting.ts_update) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>

const fields_to_check = [
  "monthly_traffic_cost_limit",
  "custom_logo",
  "initiator_info",
  "device_traffic_title",
  "device_traffic_email_template",
  "device_traffic_emails",
  "autoblock_untariffied_devices"
];

export default {
  name: 'ClientSettings',
  props: ['client_info'],

  data () {
    return {
      main_info: {},
      monthly_traffic_cost_limit: 0,
      filter_asc: "asc",
      filter_type: "",
    }
  },
  computed:{
    client_settings(){
      let client_settings = [...this.client_info.client_settings];
      return client_settings.sort(this.compareNumbers);
    },
    has_changes() {
      let main_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.main_info[key];
        return obj;
      }, {});

      let client_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.client_info[key];
        return obj;
      }, {});

      return JSON.stringify(main_info) !== JSON.stringify(client_info);
    }
  },
  created() {
    this.main_info = Object.assign(
        {},
        {
          ...this.client_info,
          autoblock_untariffied_devices: this.client_info.autoblock_untariffied_devices === 1
        }
    )
    this.monthly_traffic_cost_limit = this.client_info.monthly_traffic_cost_limit ? this.client_info.monthly_traffic_cost_limit / 100 : 0
  },
  watch:{
    client_info(){
      this.main_info = Object.assign(
          {},
          {
            ...this.client_info,
            autoblock_untariffied_devices: this.client_info.autoblock_untariffied_devices === 1
          }
      )
    },
    monthly_traffic_cost_limit(){
      this.client_info.monthly_traffic_cost_limit = Number(this.monthly_traffic_cost_limit) * 100
    }
  },
  methods: {
    edit_clients(){
      let main_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.main_info[key];
        return obj;
      }, {});

      main_info.monthly_traffic_cost_limit = Number(this.monthly_traffic_cost_limit * 100)
      main_info.autoblock_untariffied_devices = main_info.autoblock_untariffied_devices === true ? 1 : 0

      this.$http.v1.updateClient(this.main_info.id, main_info, (response) => {
        this.$emit('update_client', response.data)
        this.global_notify('info', this.translate('client.saved_success'))
        this.$store.dispatch('clientsListUpdate')
      })
    },
  }
}

</script>

<style lang='scss' scoped>
  .block_wrap{
    text-align: left;
    .line{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      text-align: left;
      margin-bottom: 10px;
      .filter{
        min-width: 100px;
        text-align: center;
        margin: 0;
      }
      .form-group{
        margin: 0;
      }
      .text_wrap{
        width: 100%;
        margin: 2.5px;
        &.flex2{
          flex: 2;
        }
        &.flex5{
          flex: 5;
        }
      }

      .input_wrap{
        width: 50%;
        margin: 2.5px;
        &.main_name{
          width: 100%;
        }
        &.parent_company{
          width: 100%;
          .vue-treeselect{
            margin-bottom: 0;
          }
        }
      }
      .button_wrap{
        width: 100%;
        text-align: right;
      }
    }
    .response_table{
      padding: 10px 0 0;
      margin: 0;
    }
  }

  textarea{
    resize: both;
  }


</style>

